import Icon from '../../components/Icon.vue'

Icon.register({"brands/tencent-weibo":{"width":384,"height":512,"paths":[{"d":"M72.3 495.8C73.7 515.7 44.7 518 42.6 498.7 31 368.8 73.7 259.2 144 185.5 128.4 151.5 153.2 108.4 194.6 108.4 224.9 108.4 249.7 133 249.7 163.5 249.7 207.5 200.2 234.3 162.8 208.6 97.1 279.9 61.4 378.4 72.3 495.8zM192 0.1C66.1 0.1-12.3 134.3 43.7 242.4 52.4 259.8 79 246.9 70 229 23.7 136.4 91 29.8 192 29.8 267.4 29.8 328.9 91.2 328.9 166.7 328.9 257.5 242 320.6 161.2 299.8 142.1 295.7 135.6 324.2 154.6 328.9 265.3 352.1 358.6 268.9 358.6 166.6 358.6 74.7 284 0.1 192 0.1z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/brands/tencent-weibo.js
// module id = null
// module chunks = 